export function customRegExp(str) {
	let lt = ['<'];
	let rt = ['>'];
	let space = /[\n\r]/;
	let remessage = str;
	remessage = remessage.replace(new RegExp(lt, 'g'), '&lt;');
	remessage = remessage.replace(new RegExp(rt, 'g'), '&gt;');
	// remessage = remessage.replace(new RegExp(space, 'g'), '&#10;');
	remessage = remessage.replace(new RegExp(space, 'g'), '<br>');

	return remessage;
}
